<script setup lang="ts">
import CommonLink from '@autobid/ui/components/common/Link.vue'
import { MenuItem } from '@headlessui/vue'
</script>

<template>
  <MenuItem
    :as="CommonLink"
    class="relative cursor-pointer p-3 font-semibold hover:bg-primary hover:text-white"
  >
    <slot />
  </MenuItem>
</template>
